/**
 * Collection page subscription frequency selector (top of page) that updates badge prices.
 * Simpler, non-intrusive version to avoid crashes.
 */
(function () {
  'use strict';

  function isCollection() {
    try {
      const mc = document.getElementById('MainContent');
      if (mc && mc.dataset && typeof mc.dataset.template === 'string') {
        return mc.dataset.template.indexOf('collection') !== -1;
      }
    } catch(_) {}
    return window.location.pathname.indexOf('/collections') === 0;
  }

  function formatMoney(cents) {
    try { if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, Shopify.money_format); } catch(_){}
    try { const cur = (Shopify && Shopify.currency && Shopify.currency.active) || 'USD'; return (Number(cents)/100).toLocaleString(undefined,{style:'currency',currency:cur}); } catch(_){ return '$'+(Number(cents)/100).toFixed(2); }
  }

  function updateAllBadges(cadenceKey) {
    // Update blue unit price badge
    document.querySelectorAll('.product-card__unit-price-badge').forEach(badge => {
      const map = {
        one: badge.getAttribute('data-unit-one'),
        week: badge.getAttribute('data-unit-week'),
        '2week': badge.getAttribute('data-unit-2week'),
        '3week': badge.getAttribute('data-unit-3week')
      };
      const cents = map[cadenceKey] || map.one;
      if (!cents) return;
      badge.textContent = formatMoney(Number(cents)) + ' / ea';
    });

    // Update black pack price badge
    document.querySelectorAll('.product-card__price-overlay').forEach(badge => {
      const map = {
        one: badge.getAttribute('data-pack-one'),
        week: badge.getAttribute('data-pack-week'),
        '2week': badge.getAttribute('data-pack-2week'),
        '3week': badge.getAttribute('data-pack-3week')
      };
      const cents = map[cadenceKey] || map.one;
      if (!cents) return;
      badge.textContent = formatMoney(Number(cents));
    });

    // Hide the green "from" badge entirely per requirements
    document.querySelectorAll('.product-card__subscription-price-badge').forEach(b => b.style.display = 'none');
  }

  // NOTE: The dynamic selector is intentionally disabled; we now use the Shopify section block only.

  function init() {
    if (!isCollection()) return;
    const key = localStorage.getItem('wd_cadence_key') || '2week';
    // If a section-based selector is present, do not render a second UI.
    if (document.querySelector('.collection-cadence-selector')) {
      updateAllBadges(key);
      return;
    }
    // Fallback removed per requirement to avoid duplicate selector
    updateAllBadges(key);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


